import LocalizedLink from '@components/Localization/LocalizedLink'
import { Button, Flex, OldText, Spinner, theme } from '@gassan-ui'
import { motion } from 'framer-motion'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import styled from 'styled-components'

const Parent = styled(motion(Flex))``

type Props = {
  price: string
  status: 'updating' | 'idle'
}

const StickySummary: FC<Props> = ({ price, status }) => {
  const { t } = useTranslation('other')
  return (
    <Parent
      justifyContent="space-between"
      alignItems="center"
      position="fixed"
      background="white"
      zIndex={theme.zIndices.cartSummary}
      left="0"
      width="100%"
      bottom="env(safe-area-inset-bottom)"
      p={['0.5rem 1rem', '0.75rem 2rem']}
      borderTop={`1px solid ${theme.colors.shades[200]}`}
      boxShadow="0px -2px 15px rgba(0, 0, 0, 0.07)"
      style={{ transform: ' translateZ(0)' }}
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 40 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
    >
      <Flex flexDirection="column">
        <OldText variant="micro" color="shades.500" mb="0.25rem" as="span">
          {t('total')}
        </OldText>
        {status === 'idle' ? (
          <OldText variant="large" mb="0" as="span">
            {price}
          </OldText>
        ) : (
          <Flex alignItems="center" color="tabaccoBrown" height="1.5rem">
            <Spinner className="text-base" />
          </Flex>
        )}
      </Flex>
      <LocalizedLink href="/checkout">
        <Button variant="dark" status={status === 'updating' ? 'disabled' : 'idle'} as="link">
          {t('order')}
        </Button>
      </LocalizedLink>
    </Parent>
  )
}

export default StickySummary
